/**
 * Google analytics helpers.
 */
export namespace Analytics {

    export function sendButtonEvent(id: string) {
        if ("ga" in window) {
            const tracker = ga.getAll()[0];
            if (tracker)
                tracker.send("event", id, "click");
        }
    }

    export function sendTiming(category: string, variable: string, value: number) {
        if ("ga" in window) {
            const tracker = ga.getAll()[0];
            if (tracker)
                tracker.send("timing", category, variable, value);
        }
    }

}